<template>
  <div class="checkbox-prop">
    <FormItem label="默认值">
      <Input
        v-model="defaultArr"
        placeholder="请输入默认值"
        readonly
        :disabled="!info.isNew"></Input>
    </FormItem>
    <FormItem label="显示边框">
      <i-switch v-model="info.form.border" />
    </FormItem>
  </div>
</template>
<script>
export default {
  name: 'CheckboxProp',
  props: {
    info: Object,
  },
  data() {
    return {
      defaultArr: null,
    }
  },
  watch: {
    'info.defaultValue'(v) {
      this.defaultArr = v && v.join()
    },
  },
  created() {

  },
}
</script>